import React from 'react';

import { AuctionItem } from 'src/pages/CatalogPage/components/AuctionItems/AuctionItem/AuctionItem';
import { TDisplayedAuctionItems } from 'src/pages/CatalogPage/CatalogPage.i';

interface IAuctionItems {
  displayedAuctionItems: TDisplayedAuctionItems;
  showPricesRealized: 0 | 1;
}

export const AuctionItems = (props: IAuctionItems) => {
  return (
    <ul>
      {props.displayedAuctionItems?.map((item) => (
        <AuctionItem
          key={item.AuctionItemID}
          item={item}
          showPricesRealized={props.showPricesRealized}
        />
      ))}
    </ul>
  );
};
